<template>
  <div id="loginmain" >
    <span class="titleline" @click="checkRegister()">没有账号，立即注册
    </span>

    <label class="loginLable" style="margin-top: 20px;">用户登录</label>
    <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules">
      <div class="username_div1">
        <el-form-item prop="username">
          <el-input prefix-icon="iconfont icon-login-username" v-model.trim="loginForm.username" placeholder="请输入用户名" @blur="getUsertype">
          </el-input>
        </el-form-item>
      </div>
      <div class="password_div1">
        <el-form-item prop="password">
          <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model.trim="loginForm.password"
            placeholder="请输入密码" type="password" @keyup.enter.native="login('loginForm')">
          </el-input>
        </el-form-item>
      </div>
      <div class="verification_div">
        <div style="width:50%;float:left">
          <el-form-item prop="picLyanzhengma">
            <el-input placeholder="请输入验证码" class="yanzhengma_input" v-model="loginForm.picLyanzhengma" prefix-icon="iconfont icon-login-validate"
              @blur="validateCheck" @keyup.enter.native="login('loginForm')"></el-input>
          </el-form-item>
        </div>
        <div style="width:50%;float:right">
          <input type="button" class="verification1 bk" @click="createCode" v-model="checkCode" />
        </div>
      </div>

      <div class="div1" >
        <div>
          <span @click="checkForgot()" class="span1" >
            忘记密码</span>
          <span @click="checkForgotUsername()" class="span2" >|
            忘记用户名</span>
        </div>
      </div>
      <div class="login-btn">
        <el-button size="medium" @click="login('loginForm')" type="primary">登录</el-button>
      </div>
    </el-form>
    <div id="some-div" style="display:none;"></div>
  </div>
</template>
<script>
  var code; //在全局定义验证码
  var officeHandshake = null;
  import {Encrypt,Decrypt} from '@/common/js/secret.js'
  export default {
    name: 'loginmain',
    data() {
      return {
        isrc:'',
        picLyanzhengma: '',
        checkCode: '',
        loginForm: {
          username: this.$parent.userName,
          password: "",
          picLyanzhengma: ""
        },
        //用户类型
        usertype: '',
        loginFormRules: {
          username: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }],
          picLyanzhengma: [
            {
              validator: (rule, value, callback) => {
                if(this.usertype == "GLY"){
                  callback();
                }else{
                  if (value == null || value == "") {
                    callback(new Error("请输入验证码"));
                  } else {
                    if (value.toUpperCase() != this.checkCode) {
                      callback(new Error("验证码不正确"));
                    } else {
                      callback();
                    }
                  }
                }

              },
              trigger: "blur"
            }

          ]
        },

      }
    },

    created() {
      this.createCode();
    },

    mounted() {
      this.init();
      this.$refs["loginForm"].resetFields();
      this.initPostmate()
    },
    methods: {
      checkRegister: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = true;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.registermain.init();
      },
      checkForgot: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = true;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.forgetpasswordmain.init();
      },
      checkForgotUsername: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = true;
        this.$parent.$refs.forgetusernamemain.init();
      },
      init: function() {
      this.$refs["loginForm"].resetFields();
        if (this.$parent.userName != "") {
          this.loginForm.username = this.$parent.userName;
        }

      },
      //获取用户类型
      getUsertype() {
        let vm = this;
        if(vm.loginForm.username!="" && (vm.usertype==null || vm.usertype=="")){
          vm.$axios.get('/account/doFindUsertype/' + vm.loginForm.username).then(function(res) {
            if(res.data.result!=null){
              if(res.data.result.usertype==null || res.data.result.usertype==""){
                vm.usertype = "GLY";
              }else{
                vm.usertype = res.data.result.usertype;
              }
            }
          }.bind(this), function(error) {
            console.log(error)
          })
        }
      },
      //验证码校验
      validateCheck() {
        //验证码错误
        if (this.loginForm.picLyanzhengma.toUpperCase() != this.checkCode) {
          // this.validateAlertFlag = true;
          //刷新Verification Code
          this.createCode();
          this.loginForm.picLyanzhengma = '';
          return false;
        } else {
          //清空所有红字提醒
          this.validateAlertFlag = false;
          return true;
        }
      },
      // 图片验证码
      createCode() {
        code = "";
        var codeLength = 4; //验证码的长度
        var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
          'M', 'N', 'O', 'P', 'Q', 'R',
          'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //随机数
        for (var i = 0; i < codeLength; i++) { //循环操作
          var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
          code += random[index]; //根据索引取得随机数加到code上
        }
        this.checkCode = code; //把code值赋给验证码
      },
      // 失焦验证图和密码
      checkLpicma() {
        this.loginForm.picLyanzhengma.toUpperCase(); //取得输入的验证码并转化为大写
        if (this.loginForm.picLyanzhengma == '') {
          // $(".login_content1 span:eq(2)").text("请输入验证码")
          // $(".login_content1 span:eq(2)").removeClass("disappear");
        } else if (this.loginForm.picLyanzhengma.toUpperCase() != this.checkCode) { //若输入的验证码与产生的验证码不一致时
          this.$alert('验证码错误', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.createCode(); //刷新验证码
              this.loginForm.picLyanzhengma = '';
            }
          });
          // $(".login_content1 span:eq(2)").removeClass("disappear");

        } else { //输入正确时
          // $(".login_content1 span:eq(2)").addClass("disappear");
          // $(".login_content1 span:eq(2)").text("请输入验证码")
          return true;
        }

      },
      //初始化通信组件
      initPostmate() {
      	if(officeHandshake) {
      		officeHandshake.destroy();
      		officeHandshake = null;
      	}
      	const me = this;
        let url = window.config.portalUrl + "#/loginNoPage"
      	const postmate = new Postmate({
      		container: document.getElementById("some-div"),
      		url: url
      	});
      	postmate.then(handshake => {
      		officeHandshake = handshake;
      		//绑定事件
      		handshake.on("toindex", me.toindex.bind(me));
      	});
      },
      toindex:function() {
        this.$router.push({path: '/index'});
      },
      //登录
      login: function(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let vm = this;
            var params = {
              username: vm.loginForm.username,
              password: Encrypt(vm.loginForm.password)
            }
            vm.$axios.post('/login', params).then(function(res) {
              if (res.data.code == '00000000') {
                localStorage.removeItem('isLogin');
                localStorage.removeItem('XTOKEN');
                localStorage.removeItem('CURRENTUSER');
                localStorage.setItem('isLogin', 'TRUE');
                localStorage.setItem('XTOKEN', res.data.result.token);
                localStorage.setItem('CURRENTUSER', JSON.stringify(res.data.result.currentUser));
                this.CONSTANT.currentUser = res.data.result.currentUser;
                
                //登录门户
                if(officeHandshake){
                  let data = {}
                  data.isLogin = 'TRUE'
                  data.XTOKEN = res.data.result.token
                  data.CURRENTUSER = res.data.result.currentUser
                  officeHandshake.call("login", data);
                  if(this.$parent.searchVal!=null){
                    this.$parent.searchVal.showView = false;
                  };
                }else{
                  if(this.$parent.searchVal!=null){
                    this.$parent.searchVal.showView = false;
                  };
                  //通信门户失败直接跳转
                 this.$router.push({path: '/index'});
                }
                
              } else if (res.data.code == '22222222') {
                this.$message.error("账号不存在");
              } else if (res.data.code == '33333333') {
                this.$message.error("密码不正确");
              } else {
                this.$message.error("登录失败");
                this.$router.push({
                  path: '/'
                });
              }
            }.bind(this), function(error) {
              console.log(error)
            })
          } else {
            console.log("error save!!");
            return false;
          }
        });
      },


    }
  };
</script>
<style lang="scss">
#loginmain{
  .div1{
    display: block;
    position: absolute;
    right: 0;
    bottom: 3rem;
    text-align: right;
  }
  .span1{
    font-size: 1rem;
    color: #409eff;
    display: inline-block;
    width: auto;
    height: auto;
  }
  .span2{
    margin-left: 0.5rem;
    float: right;
    font-size: 1rem;
    color: #409eff;
    display: inline-block;
    width: auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/LoginMain.vue